import { TaskFieldSection, TaskSectionPropertiesBase } from '../task-section';

export interface TaskLocationSectionValue {
  location: string;
  sublocation?: string;
  sublocationZone?: string;
}

export enum TaskLocationType {
  OneLevel = 'OneLevel',
  Sublocations = 'Sublocations',
  SublocationsWithZones = 'SublocationsWithZones',
}

export interface TaskLocationTypeOption {
  value: TaskLocationType;
  label: string;
}

export interface TaskLocationSectionProperties extends TaskSectionPropertiesBase {
  locationType: TaskLocationType;
  locationPlaceholder?: string;
  sublocationPlaceholder?: string;
  sublocationZonePlaceholder?: string;
}

export type TaskLocationSection = TaskFieldSection<TaskLocationSectionProperties>;
